import {defineAsyncComponent} from 'vue'
const PaymentsRouter = [
  {
    path: 'payment_signs',
    name: 'PaymentSigns',
    component: () => import('@/views/Payments/PaymentSigns/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  // 结算数据
  {
    path: 'settlement',
    name: 'Settlement',
    component: () => import('@/views/Payments/Settlement/Index.vue'),
    meta: {
      key: 'stats'
    },
  },
]
export {PaymentsRouter}
